module.exports = __webpack_public_path__ + "static/img/dyjfhj-details.4e555fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dyjfhj-details.png
// module id = 9oRV
// module chunks = 0